var map = {
	"./article_personalizer.png": 18102,
	"./e-commerce_personalization.png": 45677,
	"./globe-black.png": 1162,
	"./globe-white.png": 24828,
	"./japan.png": 83871,
	"./logo.png": 82806,
	"./logo_horizontal.png": 14875,
	"./logo_white.png": 47852,
	"./logo_white_horizontal.png": 61293,
	"./lumen.svg": 12378,
	"./maira-advisor-icon.png": 6956,
	"./nlu.png": 71180,
	"./processing.gif": 13633,
	"./recommender.png": 27532,
	"./skyrocket_business.png": 86359,
	"./wyre.svg": 45788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;